<template>
  <div class="page_box">
    <div class="active_header">
      <img :src="bannder" />
    </div>
    <div class="active_name">
      <span>{{ title }}</span>
    </div>
    <div class="box">
      <template v-if="activitys_data.length != 0">
        <activitysItem
            v-for="(item, i) in activitys_data"
            :key="i"
            :class="{ is_left: (i + 1) % 2 == 1 }"
            :default_img="default_img"
            :img_important="img_important"
            :item="item"
        ></activitysItem>
      </template>
      <div class="loading_all_center">
        <isAllDataTip
            v-if="total != 0 && total == activitys_data.length"
        ></isAllDataTip>
        <isLoadingTip v-if="loading"></isLoadingTip>
      </div>
      <noDataImg v-if="activitys_data.length == 0 && !loading" />
    </div>
  </div>
</template>
<script>
import noDataImg from "@/baseComponents/noDataImg";
import isLoadingTip from "@/baseComponents/isLoadingTip";
import isAllDataTip from "@/baseComponents/isAllDataTip";
import activitysItem from "~dlc/components/index/activitys/activitysItem";
export default {
  components: {
    noDataImg,
    isLoadingTip,
    isAllDataTip,
    activitysItem,
  },
  data() {
    return {
      is_all: false,
      bannder:
          "https://attached-file.oss-cn-shanghai.aliyuncs.com/ailaworldImgs/siffa/index/Banner_tree.png",
      title: "协会动态",
      default_img: "https://attached-file.oss-cn-shanghai.aliyuncs.com/ailaworldImgs/trf/hyzf.jpg",
      loading: false,
      total: 6,
      currentPage: 1,
      content_type: "",
      activitys_data: [],
    };
  },
  mounted() {
    this.getList(1);
    window.addEventListener("scroll", this.scrollEvent, false);
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollEvent, false);
  },
  methods: {
    scrollEvent() {
      if (
          document.documentElement.scrollTop +
          document.documentElement.clientHeight >=
          document.body.scrollHeight - 354
      ) {
        if (this.total != this.activitys_data.length) {
          if (!this.is_all) {
            this.currentPage++;
            this.getList(2);
            // 防止多次出发 请求事件
            window.addEventListener("scroll", this.scrollEvent, false);
          }
        }
      }
    },
    async getList(type) {
      //type 1 条件查询  type 2 触底出发
      // 防止多次出发 请求事件
      window.removeEventListener("scroll", this.scrollEvent, false);
      this.loading = true;
      let params = {};
      params.content_type = 2
      params.start = this.currentPage - 1;
      params.limit = 6;
      params.source = this.PJSource;
      params.language = this.LOCALE === "en" ? 1 : 2;
      let res = await this.$store.dispatch(
          "API_index/getStaticContent",
          params
      );
      if (res.success) {
        this.loading = false;
        this.total = res.total;
        if (type == 2) {
          if (res.data.length == 0) {
            this.is_all = true;
          }
          this.activitys_data.push(...res.data);
        } else if (type == 1) {
          this.activitys_data = res.data;
        }
      }
    },
  },
};
</script>
<style lang="less" scoped>
.page_box {
  background: #fafafa;
}
.active_header {
  position: relative;
  padding-top: 14.6%;
  overflow: hidden;
  img {
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
}
.active_name {
  padding: 24px;
  text-align: center;
  span {
    width: 84px;
    height: 29px;
    font-size: 21px;
    font-weight: 800;
    color: #1f292e;
    line-height: 29px;
  }
}
.box {
  width: 1200px;
  margin: auto;
  display: flex;
  flex-wrap: wrap;
  min-height: 300px;
  position: relative;

  .is_left {
    margin-right: 24px;
  }
  .loading_all_center {
    padding: 15px;
    width: 100%;
    text-align: center;
  }
}
</style>
